import React from 'react'
import { Modal, Box } from '@mui/material'
import { RootState } from '../store'
import LoadingComponent from './DeterminateLoader'
import { useSelector } from 'react-redux'

interface ModalComponentProps {
  text: string
}

const ProgressModal: React.FC<ModalComponentProps> = ({ text }) => {
  const isShowProgressModal = useSelector(
    (state: RootState) => state.construction.showProgressModal,
  )

  return (
    <Modal
      open={isShowProgressModal}
      onClose={() => {}}
      slotProps={{
        backdrop: {
          sx: (theme) => ({
            zIndex: theme.zIndex.drawer + 1,
            backgroundColor: 'rgba(248, 248, 248, 0.25)',
          }),
        },
      }}
    >
      <Box
        sx={(theme) => ({
          zIndex: theme.zIndex.drawer + 1,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '60%',
          bgcolor: '#EEEEEE',
          border: 'none',
          outline: 'none',
          borderRadius: '20px',
          boxShadow: '0px 3px 5px 0px rgba(0, 0, 0, 0.25)',
          padding: '20px',
          height: '696px',
          display: 'flex',
          flexDirection: 'row',
        })}
      >
        <LoadingComponent text={text} />
      </Box>
    </Modal>
  )
}

export default ProgressModal
